import styled from '@emotion/styled';

export const MessageWrapper = styled.div`
  text-align: center;
  font-size: 1.1rem;

  h1 {
    font-size: 2.6rem;
    font-weight: normal;
    margin: 0 0 1.43rem;
  }

  a {
    color: #5c8cae;
    font-weight: bold;
    text-decoration: none;
    cursor: pointer;
    /* font-weight: bold; */
  }

  button {
    margin-top: 2rem;
  }
`;
